requestIdleCallback(() => {
  window.toggleCartDrawerCheckoutConfirmation = function() {
    const confirmationCheckbox = document.getElementById('cart-drawer-checkout-button-confirmation');
    const ctasButton = document.querySelector('.cart-drawer__ctas button');
    const dynamicCheckoutButtons = document.querySelector('.cart-drawer__dynamic-checkout-buttons');

    ctasButton[confirmationCheckbox.checked ? 'removeAttribute' : 'setAttribute']('disabled', true);

    if (dynamicCheckoutButtons) {
      dynamicCheckoutButtons.classList[confirmationCheckbox.checked ? 'remove' : 'add']('cart-drawer__dynamic-checkout-buttons--disabled');
    }

    const aviso = document.getElementById('armonia-tarjeta-aviso-drawer');
    if (aviso) aviso.hidden = !confirmationCheckbox.checked;
  };

  themeBase.onWindowLoadTrigger(function() {
    toggleCartDrawerCheckoutConfirmation();
  });
});